require('./src/styles/globals.css');
